import { render, staticRenderFns } from "./MyPerformanceRedaction.vue?vue&type=template&id=4e6b3ee2&scoped=true"
import script from "./MyPerformanceRedaction.vue?vue&type=script&lang=ts"
export * from "./MyPerformanceRedaction.vue?vue&type=script&lang=ts"
import style0 from "./MyPerformanceRedaction.scss?vue&type=style&index=0&id=4e6b3ee2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6b3ee2",
  null
  
)

export default component.exports